export default [
    {
        path: 'relatorio-quantitativo-dispensacao',
        component: () => import(
            /* webpackChunkName: 'farmacia-relatorio-quantitativo-dispensacao' */
            '@/views/farmacia/relatorio-quantitativo-dispensacao/Index'
        ),
        redirect: 'relatorio-quantitativo-dispensacao/index',
        children: [
            {
                name: 'farmacia-relatorio-quantitativo-dispensacao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'farmacia-relatorio-quantitativo-dispensacao' */
                    '@/views/farmacia/relatorio-quantitativo-dispensacao/List.vue'
                ),
            },
        ],
    },
]